/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: FoodCost.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/BaseEnvironments/FoodCost.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 20/03/24, 11:02;
 * Updated at: 20/03/24, 11:01;
 *
 *
 */

import { getModule } from '../Utility/ModuleUtility';

export var Environment = () => {
  var Materiali = [
    { id: 71, label: 'Complementi' },
    { id: 72, label: 'Materiali' },
  ]
  var env = {
    Modules: {
      FoodCost: true,
      DistintaBase: true,
      Prodotti: true,
    },
    filtrife: [],
    AcquistiAddOn: {
      hideBrand: true,
      hideAggiunte: true,
      hideStock: true
    },
    MaterialiAddOn: {
      Ordine: true,
      StatiAcquisti: true,
      CampiAggiuntivi: [
        { nome: 'Ubicazione', oggetti: ['ubicazione'], modificabile: true, inputType: 'text', class: 'col-lg-3' },
      ],
    },
    ProdottiAddOn: {
      magazzino: true,
      scortaMinima: true,
      taglie: true,
      CampiAggiuntivi: [
        {
          nome: 'Costo', oggetti: ['costo'], modificabile: true, inputType: 'number', class: 'col-lg-3', azioni: [
            { ExternalOnClick: 'CalcCosto', icon: 'fas fa-sync', hideif: {}, tooltip: 'Calcola Costo', color: 'green' },
          ]
        },
        { nome: 'Scorta Minima', oggetti: ['scortaMinima'], modificabile: true, inputType: 'number', class: 'col-lg-3' },
        { nome: 'Ubicazione', oggetti: ['ubicazione'], modificabile: true, inputType: 'text', class: 'col-lg-3' },
      ],
    },
    ProgettiAddon: {
      lavorato: false,
      CampiAggiuntivi: [
        { nome: 'prodotti.DiscountPerc', oggetti: ['sconto'], modificabile: false, inputType: 'number', MathOperation: { MathType: '-', NumType: 'percentage' } },
        { nome: 'Accettato', oggetti: ['spedito'], modificabile: false, inputType: 'checkbox', hideif: { fieldexist: ['scarico'], fieldnotexist: ['spedire'] } }
      ],
      CampiOfferta: [
        {
          nome: 'Offerta.Tipo',
          source: 'TipiProgetti',
          oggetti: ['tipoProgetto'],
          internalOutput: 'tipoProgetto',
          modificabile: true,
          OnChange: 'OnTipoChange',
          inputType: 'singleDropdown',
          placeholder: 'Tipo di ordine',
          disabledif: { fieldexist: 'tipoProgetto' },
          settings: {
            selectIfSingle: true,
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'nome',
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
      ],
      TipiProgetto: [
        {
          nome: 'Ordine di Acquisto',
          id: "V",
          VociFields: [{ nome: "scarico", value: false }, { nome: "spedire", value: true }],
          capacita: ['ordine-vendita'],
          colore: "#1baa03"
        },
        // {
        //   nome: 'Ordine di Produzione',//viene fornita la materia dall'esterno (non scarica magaz parti)
        //   id: "P",
        //   VociFields: [{ nome: "scarico", value: false }, { nome: "spedire", value: false }],
        //   capacita: ['ordine-produzione'],
        //   colore: "#2d4295"
        // },
        {
          nome: 'Ordine conto terzi',//viene fornita la materia dall'esterno ma scarica magazzino parti
          id: "P",
          VociFields: [{ nome: "scarico", value: true }, { nome: "spedire", value: true }],
          capacita: ['ordine-produzione'],
          colore: "#2d4295"
        },
        {
          nome: 'Ordine di Lavorazione',
          id: "L",
          VociFields: [{ nome: "scarico", value: true }, { nome: "spedire", value: true }],
          capacita: ['ordine-lavorazione'],
          colore: "#826a00"
        },
        {
          nome: 'Ordine Interno',
          id: "I",
          VociFields: [{ nome: "scarico", value: true }, { nome: "spedire", value: false }],
          capacita: ['ordine-interno'],
          colore: "#cc02ea"
        }
      ],
      VociCostoButtons: [
        { ExternalOnClick: 'OnEditScheda', icon: ' fas fa-box-open', hideif: { hasCapacity: ['is-cliente-ordine'], fieldnotexist: 'scarico' }, tooltip: 'Edit Scheda di Lavorazione', color: 'green' },
        { ExternalOnClick: 'Spedisci', icon: 'fas fa-check ml-3', hideif: { hasCapacity: ['is-cliente-ordine'], fieldexist: ['spedito', 'scarico'], fieldnotexist: ['spedire'] }, tooltip: 'Conferma', color: 'green' },
      ]
    },
    Menu: [
      {
        path: "acquisti/acquisti/",
        title: "Ordini di Acquisto",
        icon: "mdi mdi-barcode",
        capacita: ["gestione-prodotti"]
      },
      {
        path: "distinta/list/",
        title: "Distinte Base",
        icon: "mdi mdi-barcode",
        capacita: ["gestione-prodotti"]
      },
      {
        module: "Prodotti",
        path: "progetti/prodotti",
        title: 'menu.ProdottiLabel',
        icon: "mdi mdi-barcode-scan",
        capacita: ["menu-prodotti"]
      }
    ],
  };
  Materiali.forEach(element => {
    env.Menu = [{
      path: `materiali/list/${element.id}`,
      title: element.label,
      icon: "mdi mdi-barcode",
      capacita: ["gestione-prodotti"]
    }, ...env.Menu];
  })
  return env;
}



export var environment = getModule(Environment());
